module.exports = __webpack_public_path__ + "media/images/icons/close-3993fb4adf67dd3d3b748536cb660a88.svg";